import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Image from '../../../components/Image';
import GridCols from './img/grid-cols.png';
import GridLayouts from './img/grid-layouts.png';
import GridAround from './img/grid-around.png';
import GridHoly from './img/grid-holy.png';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "grid"
    }}>{`Grid`}</h1>
    <p>{`The grid system helps maintain a horizontal rhythm to the page. All major layout-ing elements should line up to the columns`}</p>
    <h2 {...{
      "id": "grid-container"
    }}>{`Grid container`}</h2>
    <p>{`The container constrains the grid system to a max width of `}<inlineCode parentName="p">{`1140px`}</inlineCode>{`. On smaller screen sizes the container shrinks to take up the available space on screens. More on this later.`}</p>
    <h2 {...{
      "id": "grid-sizes"
    }}>{`Grid sizes`}</h2>
    <p>{`The grid composes 24 columns of `}<inlineCode parentName="p">{`32px`}</inlineCode>{` each with gutters of `}<inlineCode parentName="p">{`16px`}</inlineCode>{`. All borders and paddings are included within the widths, since `}<inlineCode parentName="p">{`border-box`}</inlineCode>{` is applied on the grid.`}</p>
    <Image imageWidth={620} imageHeight={346} src={GridCols} mdxType="Image" />
    <h2 {...{
      "id": "mixed-grids"
    }}>{`Mixed grids`}</h2>
    <p>{`The grid layout can be easily extended by mixing different column sizes. It is also possible to nests columns within a single column.`}</p>
    <Image imageWidth={620} imageHeight={346} src={GridLayouts} mdxType="Image" />
    <h2 {...{
      "id": "offset"
    }}>{`Offset`}</h2>
    <p>{`Its possible to leave a few columns "blank". Its not necessary to use all available columns when considering a layout.`}</p>
    <p>{`You chose to leave a gap of a few columns between elements.`}</p>
    <h2 {...{
      "id": "example-layouts"
    }}>{`Example layouts`}</h2>
    <p>{`In the example below is a multi column layout centered on the page,while leaving a gap of `}<inlineCode parentName="p">{`2 col`}</inlineCode>{` on either side.`}</p>
    <Image imageWidth={620} imageHeight={346} src={GridAround} mdxType="Image" />
    <div className="mt-10" />
    <p>{`This layout is an example of a 3 col layout with each section taking up different numer of columns.`}</p>
    <Image imageWidth={620} imageHeight={346} src={GridHoly} mdxType="Image" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      